module.exports = __webpack_public_path__ + "img/PP.fc35a3e3.png";